import Link from "next/link";
import React from "react";
import { Container } from "styles/common/container";
import {
  PrivacyPolicyContent,
  PrivacyPolicyContentContainer,
  PrivacyPolicyLanguage,
  PrivacyPolicyLanguageItem,
  PrivacyPolicyPageTitle,
  PrivacyPolicyPageTitleWrapper
} from "styles/pages/kebijakan-privasi.styles";
import { KebijakanPrivasiSEO } from "seo/kebijakan-privasi.seo";
import KebijakanPrivasiID from "components/kebijakan-privasi/kebijakan-privasi-id";
import KebijakanPrivasiEN from "components/kebijakan-privasi/kebijakan-privasi-en";
import { useKebijakanPrivasi } from "hooks/pages/use-kebijakan-privasi/user-kebijakan-privasi";

const KebijakanPrivasi: React.FC = () => {
  const { language } = useKebijakanPrivasi();

  return (
    <main>
      <KebijakanPrivasiSEO />
      <PrivacyPolicyPageTitleWrapper>
        <Container>
          <PrivacyPolicyPageTitle>
            {language === "id" ? "Kebijakan Privasi" : "Privacy Policy"}
          </PrivacyPolicyPageTitle>
        </Container>
      </PrivacyPolicyPageTitleWrapper>
      <PrivacyPolicyContentContainer>
        <PrivacyPolicyLanguage>
          <Link href="/kebijakan-privasi" passHref>
            <PrivacyPolicyLanguageItem>
              Bahasa Indonesia
            </PrivacyPolicyLanguageItem>
          </Link>
          |
          <Link href="/kebijakan-privasi?lang=en" passHref>
            <PrivacyPolicyLanguageItem>English</PrivacyPolicyLanguageItem>
          </Link>
        </PrivacyPolicyLanguage>

        <PrivacyPolicyContent>
          {language === "id" ? <KebijakanPrivasiID /> : <KebijakanPrivasiEN />}
        </PrivacyPolicyContent>
      </PrivacyPolicyContentContainer>
    </main>
  );
};

export default KebijakanPrivasi;
